/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({

    whoFollowMeSuccess: ["response"],
    whoFollowMeFailure: ["response"],

    whoFollowMeRequest: ["data"],


})

export const WhoFollowTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    data: null,
    fetching: null,
    error: null,
    pagination: null,
    dataMe: null
})


export const kargoeFailure = (state, action) => {

    return state.merge({
        fetching: false,
        error: null,
        pagination: null
    })
}
export const whoFollowMeRequest = (state, action) => {
    const { data } = action
    return state.merge({
        fetching: true,
        error: null,
        data,

    })
}




// successful unfollow user
export const whoFollowMeSuccess = (state, action) => {
    const { response: { data: { data , pagination: { newestTimestamp } }}} = action
const { dataMe } = state
console.tron.display({
    name: 'whoFollowMeSuccess',
    preview: 'You should totally expand this',
    value: {
        action: action,
        state: state,

    }
})
return state.merge({ fetching: false, dataMe: dataMe != null ? [...dataMe, ...data] : data, error: null, pagination: "" })
}

// failed unfollow user
export const whoFollowMeFailure = (state, action) => {

    console.tron.display({
        name: 'whoFollowMeFailure',
        preview: 'You should totally expand this',
        value: {
            state: state,
            action: action,
            response: action,
        }
    })
    // const error = response.data.errors ? response.data.errors[0] : true
    return state.merge({ fetching: false })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [Types.WHO_FOLLOW_ME_REQUEST]: whoFollowMeRequest,
    [Types.WHO_FOLLOW_ME_SUCCESS]: whoFollowMeSuccess,
    [Types.WHO_FOLLOW_ME_FAILURE]: whoFollowMeFailure,



})
